angular.module('angus.services')
	.factory('constantsService',
    [function() {
        return window.constants;
    }])
    .constant( 'dateCalculator', window.dateCalculator )
    .constant( 'EQ', window.ElementQueries );
